import {
  RecallType,
  DiscountType,
  PackagedBeerDetailsContainer,
  ProductCategory,
} from "../../../../gql/hooks";

const getCCValue = (value: any) => `${value ?? ""}`;

export const getCommercialConditionProducts = (
  ids: number[],
  commercialConditions?: Array<{
    packagedProductId: number;
    discountValue?: number | null;
    discountType?: DiscountType | null;
    recallValue?: number | null;
    recallType?: RecallType | null;
    recallX?: number | null;
    recallY?: number | null;
    amortizationValue?: number | null;
    amortizationType?: RecallType | null;
    amortizationX?: number | null;
    amortizationY?: number | null;
    packagedProductPrice: number;
    packagedProductUnitsNb: number;
    freePackagedProductUnitsNb?: number | null;
    x?: number | null;
    y?: number | null;
    packagedProduct?: {
      productId: number;
      product: {
        isPriceCustomizable?: boolean;
      };
      packagedDetails: any;
    } | null;
  }> | null,
  container?: PackagedBeerDetailsContainer,
) => {
  let tmpCommercialConditions = [...(commercialConditions || [])];
  return (
    ids
      .map((id: number) => {
        const itemIndex = tmpCommercialConditions.findIndex(
          (c) =>
            c.packagedProduct?.productId === id &&
            c.packagedProduct?.packagedDetails?.container === container,
        );
        if (itemIndex < 0)
          return {
            productId: id,
            container,
          };

        const item = tmpCommercialConditions[itemIndex];
        tmpCommercialConditions[itemIndex] = undefined as any;
        tmpCommercialConditions = tmpCommercialConditions.filter((_) => !!_);

        if (item) {
          return {
            productId: id,
            container,
            packagedProductId: item.packagedProductId,
            packagedProductUnitNb: getCCValue(item.packagedProductUnitsNb),
            freePackagedProductUnitsNb: getCCValue(
              item.freePackagedProductUnitsNb,
            ),
            discountValue: getCCValue(item.discountValue),
            discountType: item.discountType || DiscountType.Percentage,
            discountX: getCCValue(item.x),
            discountY: getCCValue(item.y),
            recallValue: getCCValue(item.recallValue),
            recallType: item.recallType || RecallType.LiterRecall,
            recallX: getCCValue(item.recallX),
            recallY: getCCValue(item.recallY),
            amortizationValue: getCCValue(item.amortizationValue),
            amortizationType:
              item.amortizationType || RecallType.EuroPerLiterLoan,
            amortizationX: getCCValue(item.amortizationX),
            amortizationY: getCCValue(item.amortizationY),
            customPrice: item.packagedProduct?.product.isPriceCustomizable
              ? item.packagedProductPrice
              : undefined,
            isTank: container === PackagedBeerDetailsContainer.Tank,
          };
        }
        return container && id
          ? {
              productId: id,
              container,
            }
          : null;
      })
      .filter((_: any) => !!_) || []
  );
};

export const getCommercialConditionMaterials = (
  ids: number[],
  commercialConditions?: Array<{
    packagedProductId: number;
    discountValue?: number | null;
    discountType?: DiscountType | null;
    recallValue?: number | null;
    recallType?: RecallType | null;
    amortizationValue?: number | null;
    amortizationType?: RecallType | null;
    packagedProductPrice: number;
    packagedProductUnitsNb: number;
    freePackagedProductUnitsNb?: number | null;
    x?: number | null;
    y?: number | null;
    packagedProduct?: {
      productId: number;
      product: {
        category: ProductCategory;
        isPriceCustomizable?: boolean;
      };
      packagedDetails: any;
    } | null;
  }> | null,
  customCommercialCondition?:
    | {
        proposalId: number;
        name: string;
        price: number;
        unitsNb: number;
      }[]
    | null,
) => {
  let tmpCommercialConditions = [...(commercialConditions || [])];
  const ccItems =
    ids
      .map((id: number) => {
        const itemIndex = tmpCommercialConditions.findIndex(
          (c) =>
            c.packagedProduct?.productId === id &&
            !c.packagedProduct?.packagedDetails?.container,
        );
        if (itemIndex < 0)
          return {
            productId: id,
          };

        const item = tmpCommercialConditions[itemIndex];
        tmpCommercialConditions[itemIndex] = undefined as any;
        tmpCommercialConditions = tmpCommercialConditions.filter((_) => !!_);

        if (item) {
          return {
            productId: id,
            packagedProductId: item.packagedProductId,
            packagedProductUnitNb: item.packagedProductUnitsNb,
            category: item.packagedProduct?.product.category,
          };
        }
        return id
          ? {
              productId: id,
            }
          : null;
      })
      .filter((_: any) => !!_) || [];

  const customItems =
    customCommercialCondition?.map((item) => ({
      custom: {
        name: item.name,
        price: item.price,
        unitsNb: item.unitsNb,
      },
    })) || [];

  return [...ccItems, ...customItems];
};
